/* eslint-disable react/react-in-jsx-scope */
/* -------------------------------------------------------------------------- */
/*                                Configuration                                 */
/* -------------------------------------------------------------------------- */
import React from 'react';
import ScopeFilterOperators from 'ui/components/DataGrid/Filters/ScopeFilter/ScopeFilter';
import ActiveFilterOperators from 'ui/components/DataGrid/Filters/ActiveFilter/ActiveFilter';
import TypeFilterOperators from 'ui/components/DataGrid/Filters/TypeFilter/TypeFilter';
import LanguageFilterOperators from 'ui/components/DataGrid/Filters/LanguageFilter/LanguageFilter';
import DateFilterOperators from 'ui/components/DataGrid/Filters/DateFilter/DateFilter';

/**
Table schema configuration for the module
@type {TableSchemaBase}
*/

const tableSchemaBase = [
  { field: 'user', flex: 1, headerName: 'name', minWidth: 250, fontSize: '2px', type: 'user', resizable: true },
  {
    field: 'active',
    headerName: 'activated',
    type: 'text',
    filterOperators: ActiveFilterOperators,
    minWidth: 130,
    resizable: true,
    flex: 1,
  },
  {
    field: 'internalCoach',
    headerName: 'type',
    type: 'text',
    minWidth: 130,
    filterOperators: TypeFilterOperators,
    resizable: true,
    flex: 1,
  },
  {
    field: 'scopeName',
    headerName: 'scope',
    type: 'text',
    minWidth: 250,
    filterOperators: ScopeFilterOperators,
    resizable: true,
    flex: 1,
  },
  {
    field: 'registrationDate',
    headerName: 'registration_date',
    resizable: true,
    minWidth: 180,
    type: 'text',
    flex: 1,

    filterOperators: DateFilterOperators,
  },
  {
    field: 'programsInProgress',
    headerName: 'programs_in_progress',
    type: 'text',
    minWidth: 150,
    resizable: true,
    flex: 1,
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
    align: 'center',
  },
  {
    field: 'programmesStarted',
    headerName: 'programmes_started',
    type: 'text',
    minWidth: 150,
    resizable: true,
    flex: 1,
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
    align: 'center',
  },
  {
    field: 'countProgramLast6Months',
    headerName: 'count_program_last_6_months',
    type: 'text',
    minWidth: 200,
    resizable: true,
    flex: 1,
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
    align: 'center',
  },
  {
    field: 'lastLogin',
    headerName: 'last_login',
    type: 'text',
    minWidth: 185,
    align: 'center',
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
  },
  {
    field: 'adminNote',
    headerName: 'admin_note_header',
    type: 'adminNote',
    minWidth: 185,
    flex: 1,
    align: 'center',
    disableColumnMenu: true,
    filterable: false,
    sortable: false,
  },
  {
    field: 'actions',
    headerName: 'actions',
    sortable: false,
    minWidth: 120,
    filter: false,
    filterable: false,
    valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    type: 'actionsAdmins',
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    resizable: true,
    disableColumnMenu: true,
  },
];

export { tableSchemaBase };
